import { createAction, props } from '@ngrx/store';
import { ServiceRequestPaymentInputState } from './service-request-payment-input.state';

/** StateDetailsActions */
const ACTION_SET = '[ServiceRequestPaymentInputState] set';
const ACTION_UPDATE = '[ServiceRequestPaymentInputState] update';
const ACTION_RESET = '[ServiceRequestPaymentInputState] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setStateServiceRequestPaymentInput = createAction(ACTION_SET, props<ServiceRequestPaymentInputState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateStateServiceRequestPaymentInput = createAction(
  ACTION_UPDATE,
  props<Partial<ServiceRequestPaymentInputState>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetStateServiceRequestPaymentInput = createAction(ACTION_RESET);
